module.exports = __webpack_public_path__ + "static/media/nb6.20a45e98.jpg";